$(".allpb-application__block:not(:first-of-type) .allpb-application__block-main").hide();
$(".allpb-application__block:first-of-type .allpb-application__block-toggler").addClass("active");
$(".allpb-application__block-toggler").on("click", function () {
	$(".allpb-application__block-toggler").not(this).removeClass("active");
	$(".allpb-application__block-toggler").not(this).closest(".allpb-application__block").find(".allpb-application__block-main").slideUp();
	$(this).addClass("active");
	$(this).closest(".allpb-application__block").find(".allpb-application__block-main").slideDown();

	//vform.applyEvents($(".allpb-application__block-main"));
});

$(".allpb-application__block-next").on("click", function () {
	if (application.validateStep(this))
	{
		$(this).closest(".allpb-application__block").find(".allpb-application__block-toggler").removeClass("active");
		$(this).closest(".allpb-application__block").find(".allpb-application__block-main").slideUp();
		$(this).closest(".allpb-application__block").next(".allpb-application__block").find(".allpb-application__block-toggler").addClass("active");
		$(this).closest(".allpb-application__block").next(".allpb-application__block").find(".allpb-application__block-main").slideDown();

		$(this).closest(".allpb-application__block").next(".allpb-application__block").find(".form-textarea--autoheight").each(function () {
			this.style.height = 'auto';
			this.style.height = (this.scrollHeight) + 2 + 'px';
		});
	}

	//vform.applyEvents($(".allpb-application__block-main"));
});

$(".allpb-application__block-back").on("click", function () {
	$(this).closest(".allpb-application__block").find(".allpb-application__block-toggler").removeClass("active");
	$(this).closest(".allpb-application__block").find(".allpb-application__block-main").slideUp();
	$(this).closest(".allpb-application__block").prev(".allpb-application__block").find(".allpb-application__block-toggler").addClass("active");
	$(this).closest(".allpb-application__block").prev(".allpb-application__block").find(".allpb-application__block-main").slideDown();

	//vform.applyEvents($(".allpb-application__block-main"));
});
